// Edit mode for user queries
// Note: DOMPurify is a global variable, not an ES module

// Function to enable edit mode for userQuery
export function enableEditMode(userQueryDiv, timestamp) {
    const userQueryP = userQueryDiv.querySelector('p.userQuery');
    const originalText = userQueryP.textContent;
    
    // Create edit container
    const editContainer = document.createElement('div');
    editContainer.className = 'edit-container';
    
    // Create textarea for editing
    const editTextarea = document.createElement('textarea');
    editTextarea.className = 'edit-textarea';
    editTextarea.value = originalText;
    editTextarea.rows = 2;
    
    // Add Enter key handling
    editTextarea.addEventListener('keypress', async (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            const modifiedQuery = editTextarea.value.trim();
            if (modifiedQuery && modifiedQuery !== originalText) {
                const allowed = window.bms?.checkSearchLimit ? await window.bms.checkSearchLimit() : true;
                if (!allowed) return;
                handleSearchWithQuery(modifiedQuery);
            }
            revertToNormalMode(userQueryDiv, editContainer, originalText);
        }
    });
    
    // Create button container
    const buttonContainer = document.createElement('div');
    buttonContainer.className = 'edit-button-container';
    
    // Create search button
    const searchBtn = document.createElement('button');
    searchBtn.className = 'edit-search-btn';
    searchBtn.textContent = 'Search';
    searchBtn.addEventListener('click', async () => {
        const modifiedQuery = editTextarea.value.trim();
        if (modifiedQuery && modifiedQuery !== originalText) {
            const allowed = window.bms?.checkSearchLimit ? await window.bms.checkSearchLimit() : true;
            if (!allowed) return;
            handleSearchWithQuery(modifiedQuery);
        }
        revertToNormalMode(userQueryDiv, editContainer, originalText);
    });
    
    // Create cancel button
    const cancelBtn = document.createElement('button');
    cancelBtn.className = 'edit-cancel-btn';
    cancelBtn.textContent = 'Cancel';
    cancelBtn.addEventListener('click', () => {
        revertToNormalMode(userQueryDiv, editContainer, originalText);
    });
    
    // Append elements
    buttonContainer.appendChild(searchBtn);
    buttonContainer.appendChild(cancelBtn);
    editContainer.appendChild(editTextarea);
    editContainer.appendChild(buttonContainer);
    
    // Replace userQuery content with edit container
    userQueryDiv.innerHTML = '';
    userQueryDiv.appendChild(editContainer);
    
    // Focus on textarea
    editTextarea.focus();
    editTextarea.select();
}

// Function to revert to normal mode
export function revertToNormalMode(userQueryDiv, editContainer, originalText) {
    // Extract timestamp from userQueryDiv id (format: userQuery-{timestamp})
    const idParts = userQueryDiv.id.split('-');
    const timestamp = idParts.length >= 2 ? idParts.slice(1).join('-') : userQueryDiv.id.replace('userQuery-', '');
    
    // Restore original userQuery structure
    userQueryDiv.innerHTML = '';
    
    // Re-add actions container (direct edit-query button)
    const actions = document.createElement('div');
    actions.className = 'userQuery-actions';

    const actionsButton = document.createElement('button');
    actionsButton.type = 'button';
    actionsButton.className = 'userQuery-actions-btn';
    actionsButton.setAttribute('data-tooltip', 'Edit Query');
    actionsButton.innerHTML = '<span class="material-symbols-rounded notranslate">edit</span>';
    actionsButton.addEventListener('click', (event) => {
        event.stopPropagation();
        enableEditMode(userQueryDiv, timestamp);
    });

    actions.appendChild(actionsButton);

    // Re-add userQuery paragraph with the original text
    const userQueryP = document.createElement('p');
    userQueryP.className = 'userQuery';
    userQueryP.textContent = DOMPurify.sanitize(originalText).replace(/\n/g, '');

    // Append userQuery first, then actions (edit button on the right)
    userQueryDiv.appendChild(userQueryP);
    userQueryDiv.appendChild(actions);
}

// Function to handle search with modified query
export function handleSearchWithQuery(query) {
    // Set the textarea value and trigger search with skipAnalysis=true
    document.getElementById('searchInput').value = query;
    // handleSearch is called via window.bms.handleSearch
    if (window.bms && window.bms.handleSearch) {
        window.bms.handleSearch(true); // Skip analysis for edited queries
    }
}
